import script from "./BaseFilterCategoryTag.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseFilterCategoryTag.vue?vue&type=script&setup=true&lang=js"

import "./BaseFilterCategoryTag.vue?vue&type=style&index=0&id=9a580ea6&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a580ea6"]])

export default __exports__